export const privacyPolicyItems = [
  {
    header: "Collection of Information",
    translated_header: "جمع المعلومات",
    key: "collect-information",
    content:
      "We may collect personal information, such as names, email addresses, and other relevant details, when voluntarily submitted by our visitors. We do not sell, trade, or rent this information to third parties.",
    translated_content:
      "قد نقوم بجمع معلومات شخصية، مثل الأسماء وعناوين البريد الإلكتروني والتفاصيل الأخرى ذات الصلة، عندما يتم تقديمها طوعًا من قبل زوارنا. نحن لا نبيع أو نتاجر أو نؤجر هذه المعلومات لأطراف ثالثة.",
  },
  {
    header: "Use of Information",
    translated_header: "استخدام المعلومات",
    key: "use-information",
    content:
      "Any personal information collected will be used for the purpose specified at the time of collection. We may use this information to respond to inquiries, send periodic emails, and improve our website based on the feedback we receive.",
    translated_content:
      "سيتم استخدام أي معلومات شخصية يتم جمعها للغرض المحدد في وقت الجمع. قد نستخدم هذه المعلومات للرد على الاستفسارات وإرسال رسائل بريد إلكتروني دورية وتحسين موقعنا على الويب بناءً على التعليقات التي نتلقاها.",
  },
  {
    header: "Protection of Information",
    translated_header: "حماية المعلومات",
    key: "protection-information",
    content:
      "We implement a variety of security measures to maintain the safety of your personal information. We do not, however, guarantee the security of information transmitted over the internet.",
    translated_content:
      "نقوم بتنفيذ مجموعة متنوعة من الإجراءات الأمنية للحفاظ على سلامة معلوماتك الشخصية. ومع ذلك، فإننا لا نضمن أمن المعلومات المنقولة عبر الإنترنت.",
  },
  {
    header: "Delivery Policy",
    translated_header: "سياسة التسليم",
    key: "delivery-policy",
    content:
      "Choose from four delivery options at purchase: Service at our centers, Pick up at our centers, Service at your location, Delivery to your location. Delivery charges apply based on your selection. Orders are processed upon confirmation and payment, with a maximum delivery time of 7 working days. ",
    translated_content:
      "اختر من بين أربعة خيارات للتوصيل عند الشراء: الخدمة في مراكزنا، الاستلام من مراكزنا، الخدمة في موقعك، التوصيل إلى موقعك. يتم تطبيق رسوم التوصيل بناءً على اختيارك. تتم معالجة الطلبات عند التأكيد والدفع، بحد أقصى لوقت التسليم 7 أيام عمل.",
  },
  {
    header: "Cancellation, Refund, and Return Policy",
    translated_header: "سياسة الإلغاء والاسترداد والإرجاع",
    key: "cancel-refund-return-policy",
    content:
      "You can cancel your order within 48 hours of placing it. If there is an issue with a delivered product, you can return it within 7 days. The refund will be processed to the card used at the time of purchase.",
    translated_content:
      "يمكنك إلغاء طلبك خلال 48 ساعة من تقديمه. إذا كانت هناك مشكلة في المنتج الذي تم تسليمه، فيمكنك إعادته خلال 7 أيام. ستتم معالجة المبلغ المسترد إلى البطاقة المستخدمة في وقت الشراء.",
  },
  {
    header: "Cookies",
    translated_header: "بسكويت",
    key: "cookies",
    content:
      "We may use cookies to enhance your experience on our website. You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. If you disable cookies, some features of our site may not function properly.",
    translated_content:
      "قد نستخدم ملفات تعريف الارتباط لتحسين تجربتك على موقعنا. يمكنك اختيار أن يقوم جهاز الكمبيوتر الخاص بك بتحذيرك في كل مرة يتم فيها إرسال ملف تعريف الارتباط، أو يمكنك اختيار إيقاف تشغيل جميع ملفات تعريف الارتباط. إذا قمت بتعطيل ملفات تعريف الارتباط، فقد لا تعمل بعض ميزات موقعنا بشكل صحيح.",
  },
  {
    header: "Third-Party Disclosure",
    translated_header: "الإفصاح عن الطرف الثالث",
    key: "third-party-disclosure",
    content:
      "We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties. This does not include trusted third parties who assist us in operating our website, conducting our business, or servicing you, as long as those parties agree to keep this information confidential.",
    translated_content:
      "نحن لا نبيع أو نتاجر أو ننقل معلومات التعريف الشخصية الخاصة بك إلى أطراف خارجية. وهذا لا يشمل الأطراف الثالثة الموثوقة التي تساعدنا في تشغيل موقعنا الإلكتروني، أو إجراء أعمالنا، أو تقديم الخدمة لك، طالما وافقت هذه الأطراف على الحفاظ على سرية هذه المعلومات.",
  },
  {
    header: "Changes to the Privacy Policy",
    translated_header: "التغييرات في سياسة الخصوصية",
    key: "changes-privacy-policy",
    content:
      "We reserve the right to update and change our Privacy Policy at any time. Any changes will be posted on this page.",
    translated_content:
      "نحن نحتفظ بالحق في تحديث وتغيير سياسة الخصوصية الخاصة بنا في أي وقت. سيتم نشر أي تغييرات على هذه الصفحة.",
  },
];

export const termsOfUseItems = [
  {
    header: "Acceptance of Terms",
    translated_header: "قبول الشروط",
    key: "accept-terms",
    content:
      "By accessing or using our website, you agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our site.",
    translated_content:
      "من خلال الوصول إلى موقعنا أو استخدامه، فإنك توافق على الالتزام بشروط الاستخدام هذه. إذا كنت لا توافق على هذه الشروط، يرجى عدم استخدام موقعنا.",
  },
  {
    header: "Intellectual Property",
    translated_header: "الملكية الفكرية",
    key: "intellectual-property",
    content:
      "All content on this website, including text, graphics, logos, and images, is the property of Higaraj and is protected by intellectual property laws.",
    translated_content:
      "جميع محتويات هذا الموقع، بما في ذلك النصوص والرسومات والشعارات والصور، هي ملك لشركة Higaraj ومحمية بموجب قوانين الملكية الفكرية.",
  },
  {
    header: "User Conduct",
    translated_header: "سلوك المستخدم",
    key: "user-conduct",
    content:
      "You agree not to use the website for any unlawful or prohibited purpose. You may not use the site in any manner that could damage, disable, overburden, or impair our servers or networks.",
    translated_content:
      "أنت توافق على عدم استخدام الموقع لأي غرض غير قانوني أو محظور. لا يجوز لك استخدام الموقع بأي طريقة قد تؤدي إلى إتلاف أو تعطيل أو إثقال أو إضعاف خوادمنا أو شبكاتنا.",
  },
  {
    header: "Limitation of Liability",
    translated_header: "تحديد المسؤولية",
    key: "limitation-liability",
    content:
      "Higaraj shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising out of your use of or inability to use the website.",
    translated_content:
      "لن تكون Higaraj مسؤولة عن أي أضرار مباشرة أو غير مباشرة أو عرضية أو تبعية أو تأديبية تنشأ عن استخدامك للموقع أو عدم قدرتك على استخدامه.",
  },
];
